import React, { FC, useState } from 'react';
import Modal from 'react-modal';
import { useLocale } from '../../../../contexts/localeContext';
import { TableContextProvider } from '../../../../contexts/table/TableContextProvider';
import { TranslationKeys } from '../../../../contexts/TranslationKeys';
import IPRangePreferenceColumns from '../../../../models/ColumnDefinitions/IPRangePreferenceColumns';
import { DeleteEntityResult } from '../../../../models/services/DeleteEntityResult';
import { getSystemUserIpRanges } from '../../../../services/userPreferenceService';
import ActivityFrame from '../../../activity-frame/activity-frame';
import TableTab from '../../../tabs/table-tab';
import Wizard from '../../../wizard/wizard';
import { deleteSettingData } from '../../../../services/settingDataService';

interface AssignModalProps {
    isOpen: boolean,
    onClose: () => any,
    handleOnSubmit: (e) => any,
}

const defaultMode = {
    id: 0,
    startIp: null,
    endIp: null,
}

const IPRanges: FC<AssignModalProps> = ({ isOpen, onClose, handleOnSubmit }) => {
    const { translate } = useLocale();
    const [selectedIpRange, setSelectedIpRange] = useState<any>(defaultMode);
    const [busy, setBusy] = useState<any>(false);

    const onSubmit = () => {
        handleOnSubmit(selectedIpRange);
        onClose();
    }

    const onRowClicked = (rowData: any) => {
        const newSelectedMode = {
            ...selectedIpRange,
            id: rowData.id,
            startIp: rowData.startIpAddress,
            endIp: rowData.endIpAddress,
        }
        setSelectedIpRange(newSelectedMode);
    }

    const onDelete = (id: string): Promise<DeleteEntityResult> => {
        setBusy(true);
        return new Promise((resolve, reject) => {
            deleteSettingData(id)
                .then(
                    deleteResult => {
                        resolve(deleteResult);
                        setBusy(false);
                    },
                    deleteResult => {
                        reject(deleteResult);
                        setBusy(false);
                    })
        });
    }

    return (
        <Modal
            isOpen={isOpen}
            ariaHideApp={false}
            overlayClassName="flex w-screen position-float-modal fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
            className="bg-white border-none m-auto shadow select-none outline-none w-content">
            <ActivityFrame busy={busy} busyMessage={translate.byKey(TranslationKeys.scanning)} className={`flex ${busy ? 'h-full w-full justify-center' : ''} flex-wrap content-center`}>
                <Wizard
                    name={translate.byKey(TranslationKeys.advancedScan)}
                    step={0}
                    onClose={onClose}
                    sidebarSteps={[]}
                    children={[<TableContextProvider
                        dataMethod={(listParameters) => getSystemUserIpRanges(listParameters)}
                        tableDescriptor={IPRangePreferenceColumns}
                        searchDescriptor={[]}
                        deleteMethod={onDelete}
                        useTable
                        usePagination
                        canExportReport={false}>
                        <TableTab
                            title={''}
                            selectRows={false}
                            onRowClicked={(data) => onRowClicked(data)}
                            cyName='ipRange'/>
                    </TableContextProvider>]} />
            </ActivityFrame>
            <div className="flex flex-row pb-3 pr-3 justify-end bg-white">
                <div className="flex flex-row mt-4 mr-5">
                    <button
                        id='saveIpRangeBtnId'
                        className={`secondary secondary-enabled py-1 px-5  ${!(selectedIpRange.id) ? 'secondary-disabled cursor-not-allowed' : 'secondary-enabled'}`}
                        onClick={onSubmit}
                        disabled={!(selectedIpRange.id) ? true : false}
                        type="submit">
                        {translate.byKey(TranslationKeys.scan)}
                    </button>
                </div>
            </div>
        </Modal>
    )
}

export default IPRanges;
